import $ from 'jquery';

// Constants
const BRACELET_SCREEN = 'bracelet';
const USER_SCREEN = 'user';
const SUCCESS_SCREEN = 'success';
const BEFORE_SCREEN = 'before';
const ENDED_SCREEN = 'ended';
const SCREENS = [BRACELET_SCREEN,USER_SCREEN,SUCCESS_SCREEN,BEFORE_SCREEN,ENDED_SCREEN];
const FIXED_SCREEN_QUERY_PARAM = 'fixed_screen';
const ALLOWED_BANK_ACCOUNT_REGIONS = ['usa', 'eurozone'];
const BRACELET_ID_LENGTH = 8;

// Configuration
const REFUNDS_ELEMENT = document.getElementById('refunds');
const API_PATH = REFUNDS_ELEMENT.dataset.cashlessPath;
const PLAN_ID = parseInt(REFUNDS_ELEMENT.dataset.planId, 10);
const BANK_ACCOUNT_REGION =
  REFUNDS_ELEMENT.dataset.bankAccountRegion?.toLowerCase();
const REFUND_START_DATE = new Date(REFUNDS_ELEMENT.dataset.startDate);
const REFUND_ENDED = REFUNDS_ELEMENT.dataset.periodEnded === 'true';

const errorConf = document.getElementById('refund-errors-conf');

const DEFAULT_ERROR_MESSAGE = errorConf.dataset.default;
const USER_ERROR_MESSAGES = {
  MISSING_BANK_DETAILS_FOR_CLAIM: () =>
    errorConf.dataset.missing_bank_details_for_claim,
  REFUND_ALREADY_CLAIMED: () => errorConf.dataset.refund_already_claimed,
  REFUND_OPENING_DATETIME_ERROR: () =>
    errorConf.dataset.refund_opening_datetime_error.replace(
      '{braceletId}',
      Alpine.store('refunds').braceletId
    ),
  WALLET_NOT_FOUND: () => errorConf.dataset.wallet_not_found,
  MORE_THAN_ONE_WALLET_FOUND: () => errorConf.dataset.contact_with_user_support,
  CODE_NOT_FOUND: () => errorConf.dataset.contact_with_user_support,
  MORE_THAN_ONE_CODE_FOUND: () => errorConf.dataset.contact_with_user_support,
  WALLET_ACCESS_CODE_BONDING_INCOMPLETE: () => errorConf.dataset.contact_with_user_support,
  REFUND_DATETIME_ENDED_ERROR: () => errorConf.dataset.refund_datetime_ended_error,
  REFUND_CONTAINS_NEGATIVE_AMOUNTS: () => errorConf.dataset.contact_with_user_support,
};

const isPlanConfigured = isPlanValid(PLAN_ID);
const isBankAccountRegionConfigured =
  isBankAccountRegionValid(BANK_ACCOUNT_REGION);

if (isPlanConfigured === false) {
  throw new Error(
    'Plan ID not found. Please, configure the plan id in the settings file'
  );
}

if (isBankAccountRegionConfigured === false) {
  throw new Error(
    'Bank Account Region is not configured. Please, configure it in order to use this feature'
  );
}

document.addEventListener('alpine:init', () => {
  Alpine.store('refunds', {
    criticalError:
      isPlanConfigured === false || isBankAccountRegionConfigured === false,
    braceletId: null,
    contactEmail: null,
    isFetchingData: false,
    isClaimed: false,
    bankAccountRegion: BANK_ACCOUNT_REGION,
    requestError: false,
    requestErrorMessage: null,
    refundData: {
      refund_id: null,
      remaining_tokens: 0,
      cash: 0,
      loyalty: 0,
      is_claimed: false,
    },
    screen: initialScreen(),
    userData: {
      aba: null,
      address: null,
      bank_account: null,
      bank_name: null,
      contact_email: null,
      full_name: null,
      iban: null,
    },
  });

  REFUNDS_ELEMENT.classList.remove('refunds-section--init');
  initSingleInputs();
});

function initSingleInputs() {
  REFUNDS_ELEMENT.querySelectorAll('[data-single-input]').forEach((element) => {
    element.addEventListener('input', ({target, data}) => {
        if(!data) {
            return;
        }
        hideBraceletError();
        const nextElementId = parseInt(target.dataset.singleInputIndex, 10) + 1;
        const nextElement = target.parentNode.querySelector(`[data-single-input-index="${nextElementId}"]`);
        if (nextElement) {
            nextElement.focus();
        }
    });
  });
}

function getFixedScreen() {
  const urlParams = new URLSearchParams(location.search);
  const fixedScreen = urlParams.get(FIXED_SCREEN_QUERY_PARAM);

  return fixedScreen && SCREENS.includes(fixedScreen) ? fixedScreen : null;
}

function initialScreen() {
  const fixedScreen = getFixedScreen();
  if (fixedScreen) {
    return fixedScreen;
  }

  if(REFUND_ENDED) {
    return ENDED_SCREEN;
  }

  return isRefundAvailable() ? BRACELET_SCREEN : BEFORE_SCREEN;
}

function isRefundAvailable() {
  return new Date() >= REFUND_START_DATE;
}

function isPlanValid(planId) {
  return planId !== null && planId !== undefined && planId !== NaN;
}

function isBankAccountRegionValid(bankAccountRegion) {
  return (
    bankAccountRegion !== null &&
    bankAccountRegion !== undefined &&
    bankAccountRegion.length !== 0 &&
    ALLOWED_BANK_ACCOUNT_REGIONS.includes(bankAccountRegion)
  );
}

function getBraceletIdFromSingleInputs() {
  let braceletId = '';
  REFUNDS_ELEMENT.querySelectorAll('[data-single-input]').forEach((element) => {
    const value = element.value.toUpperCase();
    if (value && value.match(/^[0-9A-Z]$/)) {
        braceletId += value;
    }
  });

  if (braceletId.length !== BRACELET_ID_LENGTH) {
    throw new Error(`Invalid check lenght of bracelet id ${braceletId}`);
  }
  return braceletId;
}

function userDataTransformer(formData, isThereCash, bankAccountRegion) {
  let data = {
    contact_email: formData.contact_email,
  };

  if (isThereCash) {
    data = {
      ...data,
      full_name: formData.full_name,
      bank_account_region: bankAccountRegion,
    };

    if (bankAccountRegion === 'usa') {
      data = {
        ...data,
        aba: formData.aba,
        address: formData.address,
        bank_account: formData.bank_account,
        bank_name: formData.bank_name,
      };
    }

    if (bankAccountRegion === 'eurozone') {
      data = {
        ...data,
        iban: formData.iban,
      };
    }
  } else {
    data = {
      ...data,
      bank_account_region: 'loyalty',
    };
  }

  const hasEmptyValue = Object.values(data).find(e => !e);
  if (hasEmptyValue) {
    throw new Error(DEFAULT_ERROR_MESSAGE);
  }

  return data;
}

function registerActionForm(selector, cb) {
  $(selector)
    .on('formvalid.zf.abide', () => {
      cb();
    })
    .on('submit', (ev) => {
      ev.preventDefault();
    });
}

function registerInvalidForm(selector, cb) {
  $(selector).on('forminvalid.zf.abide', () => {
    cb();
  })
}

async function handleClickButton() {
  try {
    const braceletId = getBraceletIdFromSingleInputs();
    Alpine.store('refunds').braceletId = braceletId;
    Alpine.store('refunds').isFetchingData = true;
    Alpine.store('refunds').requestError = false;
    Alpine.store('refunds').requestErrorMessage = null;

    const data = await fetchBraceletRefundData(braceletId);

    Alpine.store('refunds').isFetchingData = false;
    const isClaimed = !!data.is_claimed;
    Alpine.store('refunds').isClaimed = isClaimed;
    Alpine.store('refunds').refundData = data;
    Alpine.store('refunds').screen = isClaimed ? SUCCESS_SCREEN : USER_SCREEN;
  } catch (error) {
    Alpine.store('refunds').isFetchingData = false;
    Alpine.store('refunds').requestError = true;
    Alpine.store('refunds').requestErrorMessage = error.message;
  }
}

async function handleUserDataClickButton() {
  const userData = Alpine.store('refunds').userData;
  const isThereCash = Alpine.store('refunds').refundData.cash > 0;
  try {
    const requestData = userDataTransformer(
      userData,
      isThereCash,
      BANK_ACCOUNT_REGION
    );
    Alpine.store('refunds').isFetchingData = true;
    Alpine.store('refunds').requestError = false;
    Alpine.store('refunds').requestErrorMessage = null;

    const data = await claimBraceletRefund(
      Alpine.store('refunds').refundData.refund_id,
      requestData
    );

    Alpine.store('refunds').isFetchingData = false;
    Alpine.store('refunds').screen = SUCCESS_SCREEN;
  } catch (error) {
    Alpine.store('refunds').isFetchingData = false;
    Alpine.store('refunds').requestError = true;
    Alpine.store('refunds').requestErrorMessage = error.message;
  }
}

async function displayBraceletError() {
  REFUNDS_ELEMENT.querySelector('#bracelet-form-single-item-error').classList.add('is-visible');
}

function hideBraceletError() {
  REFUNDS_ELEMENT.querySelector('#bracelet-form-single-item-error').classList.remove('is-visible');
}

async function fetchBraceletRefundData(braceletId) {
  const cleanBraceletId = braceletId.toUpperCase();

  const rawData = await fetch(`${API_PATH}/cashless/token-wallets/refunds/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      b2c_plan_id: PLAN_ID,
      bracelet_code: cleanBraceletId,
    }),
  });

  const status = rawData.status;

  if (status === 400) {
    await handle400error(rawData);
  }

  if (status !== 200) {
    throw new Error(DEFAULT_ERROR_MESSAGE);
  }

  return rawData.json();
}

async function claimBraceletRefund(refundId, userData) {
  const rawData = await fetch(
    `${API_PATH}/cashless/refunds/${refundId}/claim/`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData),
    }
  );

  const status = rawData.status;

  if (status === 400) {
    await handle400error(rawData);
  }

  if (status !== 200) {
    throw new Error(DEFAULT_ERROR_MESSAGE);
  }

  return rawData.json();
}

function getErrorMessage(code) {
  if (!USER_ERROR_MESSAGES[code]) {
    return null;
  }
  return USER_ERROR_MESSAGES[code]();
}

async function handle400error(response) {
  const data = await response.json();
  const errorCode = data && data.error && data.error.code;
  const errorMessage = data && data.error && data.error.message;

  if (errorMessage) {
    console.error(errorMessage);
  }

  const userErrorMessage =
    getErrorMessage(errorCode) || DEFAULT_ERROR_MESSAGE;
  throw new Error(userErrorMessage);
}

registerInvalidForm('#bracelet-form', displayBraceletError);
registerActionForm('#bracelet-form', handleClickButton);
registerActionForm('#user-refund-form', handleUserDataClickButton);
